export default __webpack_public_path__ + "static/media/FileImage.de94dfe8.svg";